import { ActionIcon, Center, Group, Menu, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText, HiOutlineDotsVertical, HiOutlineExclamation } from 'react-icons/hi';
import { ReviewApproval } from 'types/lcms/courses';
import AdminSMEItem from './AdminSMEItem';

interface BeelajarLMSSectionProps {
  data?: ReviewApproval;
  courseId: string;
}

const SMEMaterialSection = ({ data, courseId }: BeelajarLMSSectionProps) => {
  const smeList = [
    ...(data?.smeInternal?.map((internal) => ({
      ...internal,
      type: 'internal',
      trLCMSSMEInternalID: internal.trLCMSSMEInternalID
    })) || []),
    ...(data?.smeExternal?.map((external) => ({
      ...external,
      type: 'external',
      trLCMSSMEExternalID: external.trLCMSSMEExternalID
    })) || [])
  ];

  return (
    <Card>
      <Stack gap={16}>
        <Group justify='space-between'>
          <Group gap={8}>
            <HiOutlineDocumentText />
            <Text c={'dark'} fw={700}>
              SME Material
            </Text>
          </Group>
          <Menu shadow='md'>
            <Menu.Target>
              <ActionIcon variant='transparent' c={'dark'}>
                <HiOutlineDotsVertical />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item leftSection={<HiOutlineExclamation />}>Close Link For SME</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>

        {smeList.length === 0 && (
          <Center>
            <Text c={'dark'} fz={'sm'} ta={'center'}>
              SME material not available yet.
            </Text>
          </Center>
        )}

        {smeList.length > 0 && (
          <Stack gap={16}>
            {smeList.map((item, index) => (
              <AdminSMEItem
                key={index}
                item={{
                  ...(item as any),
                  smeId:
                    'type' in item && item.type === 'internal'
                      ? 'trLCMSSMEInternalID' in item
                        ? item.trLCMSSMEInternalID
                        : undefined
                      : 'trLCMSSMEExternalID' in item
                        ? item.trLCMSSMEExternalID
                        : undefined
                }}
                courseId={courseId}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default SMEMaterialSection;
